export default results => {
  return results.reduce((searchResults, item) => {
    return [
      ...searchResults,
      ...Object.entries(item.prices).reduce((acc, [cabinType, cabinPrice]) => {
        if (cabinPrice !== null) {
          acc.push({
            legs: [
              {
                type: 'outbound',
                depart: item.outbound.from,
                arrive: item.outbound.to,
              },
              {
                type: 'inbound',
                depart: item.inbound.from,
                arrive: item.inbound.to,
              },
            ],
            cabin: cabinType,
            price: cabinPrice,
          })
        }
        return acc
      }, []),
    ]
  }, [])
}